import React from "react";
import { Trans } from "react-i18next";
import { useStyles } from "../../../assets/jss/PraisoTable";
import { TransformationType } from "../../../config/app-globals.enum";

export const TransformedCell = (props) => {
  const classes = useStyles();
  // React.useEffect(() => {
  //   if (props.transformationRule.type.from === TransformationType.OBJECT) {
  //     console.log("props", props);
  //   }
  // }, [props]); 
  return (
    <>
      {props && props.transformationRule && props.transformationRule.type ? (
        <>
          {props.transformationRule.type.to &&
            props.transformationRule.type.from ? (
            <>
              {props.transformationRule.type.to === TransformationType.TEXT ? (
                <>
                  {props.transformationRule.type.from ===
                    TransformationType.ARRAY_DATA ? (
                    <>
                      {props.originalData && props.originalData.length
                        ? props.originalData.map((item) => {
                          return (
                            <>
                              {props.transformationRule.data &&
                                props.transformationRule.data[item] ? (
                                <Trans
                                  i18nKey={`TRANSFORMED_CELL_TEXT_${props.transformationRule.data[
                                    item
                                  ].replace(/\s/g, "")}`}
                                >
                                  {item === props.originalData[props.originalData.length - 1] ? props.transformationRule.data[item] : props.transformationRule.data[item] + ", "}
                                </Trans>
                              ) : null}
                            </>
                          );
                        })
                        : (
                          <Trans
                            i18nKey={`TRANSFORMED_CELL_TEXT_${props.transformationRule.data[
                              props.cellValue
                            ].replace(/\s/g, "")}`}
                          >
                            {
                              props.transformationRule.data[
                              props.cellValue
                              ]
                            }
                          </Trans>
                        )}
                    </>
                  ) : (
                    <>
                      {props.transformationRule.type.from ===
                        TransformationType.OBJECT_DATA ? (
                        <>
                          {props.originalData &&
                            props.transformationRule.dataMapProperty &&
                            props.originalData[
                            props.transformationRule.dataMapProperty
                            ] ? (
                            <Trans
                              i18nKey={`TRANSFORMED_CELL_TEXT_${props.originalData[
                                props.transformationRule.dataMapProperty
                              ].replace(/\s/g, "")}`}
                            >
                              {
                                props.originalData[
                                props.transformationRule.dataMapProperty
                                ]
                              }
                            </Trans>
                          ) : null}
                        </>
                      ) : (
                        <>
                          {props.transformationRule.type.from ===
                            TransformationType.EXCEPTION_DATA ? (
                            <>
                              {props.cellValue ? (
                                <>
                                  {props.transformationRule.data &&
                                    props.transformationRule.data[
                                    props.cellValue
                                    ] ? (
                                    <Trans
                                      i18nKey={`TRANSFORMED_CELL_TEXT_${props.transformationRule.data[
                                        props.cellValue
                                      ].replace(/\s/g, "")}`}
                                    >
                                      {
                                        props.transformationRule.data[
                                        props.cellValue
                                        ]
                                      }
                                    </Trans>
                                  ) : props.cellValue}
                                </>
                              ) : null}
                            </>
                          ) : (
                            <>
                              {props.cellValue &&
                                props.transformationRule.data &&
                                props.transformationRule.data[props.cellValue] ? (
                                <Trans
                                  i18nKey={`TRANSFORMED_CELL_TEXT_${props.transformationRule.data[
                                    props.cellValue
                                  ].replace(/\s/g, "")}`}
                                >
                                  {
                                    props.transformationRule.data[
                                    props.cellValue
                                    ]
                                  }
                                </Trans>
                              ) : null}
                            </>
                          )}
                        </>
                      )}
                    </>
                  )}
                </>
              ) : props.transformationRule.type.to ===
                TransformationType.IMAGE ? (
                <>
                  {props.cellValue &&
                    props.transformationRule.data &&
                    props.transformationRule.data[props.cellValue] ? (
                    <>
                      <img
                        src={`/${props.transformationRule.data[props.cellValue]
                          }`}
                        alt={props.transformationRule.data[props.cellValue]}
                      />
                    </>
                  ) : null}
                </>
              ) : null}
            </>
          ) : null}
        </>
      ) : null}
    </>
  );
};
